
import actions from './actions'
import mutations from './mutations'

let state = {
    all: null,
    count: 0,
    current: null,
    page: 1
}

const ACTIONS = {
    GET: 'bordereauxLivraison/get',
    GET_ALL: 'bordereauxLivraison/getAll',
    GET_NEXT: 'bordereauxLivraison/getNext'
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}

export { ACTIONS as actions }